function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFollow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.399,1.033C13.292,1.033 12.399,1.926 12.399,3.033L12.399,4.233C7.836,5.158 4.399,9.195 4.399,14.033L4.399,15.207C4.399,18.145 3.318,20.982 1.368,23.182L0.905,23.701C0.38,24.289 0.255,25.132 0.574,25.851C0.893,26.57 1.611,27.032 2.399,27.032L26.398,27.032C27.186,27.032 27.898,26.57 28.223,25.851C28.548,25.132 28.417,24.289 27.892,23.701L27.43,23.182C25.48,20.982 24.398,18.151 24.398,15.207L24.398,14.033C24.398,9.195 20.961,5.158 16.399,4.233L16.399,3.033C16.399,1.926 15.505,1.033 14.399,1.033ZM17.23,31.864C17.98,31.114 18.399,30.095 18.399,29.032L10.399,29.032C10.399,30.095 10.817,31.114 11.567,31.864C12.317,32.614 13.336,33.032 14.399,33.032C15.461,33.032 16.48,32.614 17.23,31.864Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFollow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/follow.1047daebcea94ad11908012e112083ee.svg";